import { HttpInterceptorFn } from '@angular/common/http'
import { catchError, of, take, throwError, timeout } from 'rxjs'
import { NotificationService } from '../notification.service'
import { inject } from '@angular/core'
import { Store } from '@ngrx/store'
import { AppState } from '../core.state'
import { authActions } from '../auth/auth.actions'
import { RegisterUploadedDocumentsService } from 'src/app/shared/services/register-uploaded-documents.service'
import { Actions, ofType } from '@ngrx/effects'
import { memberActions } from 'src/app/features/member/member.actions'
import { Router } from '@angular/router'
import { operationActions } from 'src/app/features/operation/operation.actions'
import { AppRoutesNS } from 'src/app/app-routes.namespace'
import { SUPPRESS_HTTP_ERROR_NOTIFICATION } from './error-notification.context'

const MEMBER_STATUS_BLOCKED_REASON = 'MEMBER_STATUS_BLOCKED'

export const ErrorHandlerInterceptorInterceptor: HttpInterceptorFn = (
  req,
  next
) => {
  const notificationService = inject(NotificationService)
  const store = inject(Store<AppState>)
  const registerUploadDocumentService = inject(RegisterUploadedDocumentsService)
  const actions$ = inject(Actions)
  const router = inject(Router)

  return next(req).pipe(
    catchError((err: any) => {
      console.log('ErrorHandlerInterceptorInterceptor caught error:', err)

      const errors = err?.error?.message || err.statusText

      console.error(errors, err.status)
      store.dispatch(
        authActions.logHttpError({
          error: errors,
          status: err.status,
          path: req.url
        })
      )

      if (req.context.get(SUPPRESS_HTTP_ERROR_NOTIFICATION)) {
        return throwError(() => err)
      }

      if (err?.error?.additionalInfo?.attemptedAction === 'PENDING_OPERATION') {
        store.dispatch(operationActions.fetchMyOperations({}))
        router.navigateByUrl(AppRoutesNS.Operations.OPERATIONS)
        return throwError(() => err)
      }

      switch (err.status) {
        case 401:
          if (
            err?.error?.additionalInfo?.reason === MEMBER_STATUS_BLOCKED_REASON
          ) {
            console.log(err)
            if (err?.error?.additionalInfo?.attemptedAction == 'BLOCKED') {
              console.log(
                'getUploadedFiles',
                registerUploadDocumentService.getUploadedFiles()
              )
              if (
                err?.error?.additionalInfo?.id &&
                registerUploadDocumentService.getUploadedFiles()?.length
              ) {
                console.log(
                  'did get up getUploadedFiles',
                  registerUploadDocumentService.getUploadedFiles()
                )
                registerUploadDocumentService.saveUploadedFile({
                  id: err?.error?.additionalInfo?.id
                })

                actions$
                  .pipe(
                    ofType(memberActions.createOneDocumentLink),
                    take(1),
                    timeout(5000),
                    catchError((error) => of(null))
                  )
                  .subscribe((action) => {
                    if (!action) {
                      console.warn('There was a problem saving the document')
                    }

                    store.dispatch(
                      authActions.logout({ loginErrorMessage: errors })
                    )
                  })
              } else {
                store.dispatch(
                  authActions.logout({ loginErrorMessage: errors })
                )
              }
            } else {
              store.dispatch(authActions.logout({ loginErrorMessage: errors }))
            }
            store.dispatch(
              authActions.setLoginErrorMessage({ message: errors })
            )
          } else if (
            typeof errors === 'string' &&
            errors.includes('Login failure message:')
          ) {
            store.dispatch(
              authActions.setLoginErrorMessage({ message: errors })
            )
          } else if (
            // generic 401 refresh + replay is handled by AuthRetryInterceptor
            errors == 'Refresh token expired' &&
            (err?.error?.additionalInfo?.attemptedAction == 'BLOCKED' ||
              err?.error?.additionalInfo?.attemptedAction ==
                'ACTIVE_NO_PAYMENT')
          ) {
            store.dispatch(authActions.logout({ loginErrorMessage: errors }))
            store.dispatch(
              authActions.setLoginErrorMessage({ message: errors })
            )
          }
          break
        case 400:
        case 403:
          const noNotificationErrors = [
            'Unable to purchase: Unable to purchase a due later payment product without a valid direct debit mandate'
          ]
          if (
            typeof errors == 'string' &&
            noNotificationErrors.includes(errors)
          ) {
            // dont notify silected errors
            console.log(
              'Wont show notification as its a marked as for no notifcation'
            )
            break
          }

          if (errors && errors instanceof Array && errors.length) {
            errors.map((x) => {
              if (typeof x == 'string') {
                notificationService.emit(x, 'warning')
              }
              Object.values(x.constraints).map((constraint) =>
                notificationService.emit(constraint.toString(), 'warning')
              )
            })
          } else if (errors) {
            notificationService.emit(errors.toString(), 'warning')
            if (
              errors.toString().includes('Session expired, please log in again')
            )
              store.dispatch(authActions.logout({}))
          } else {
            notificationService.emit('alerts.badRequest', 'warning')
          }
          break
        default:
          if (errors != 'OK') notificationService.emit(errors, 'error')
      }

      return throwError(() => err)
    })
  )
}
